import { dataHooks } from '@wix/data-hooks';

export const menuListDataHooks = dataHooks<{
  root: {};
  menuTitle: {};
  menuDescription: {};
  menuAvailabilityNotification: {};
  divider: {};
}>('menu-list');
